import { render } from "./ResearchItsTechComp.vue?vue&type=template&id=ee72775a&scoped=true"
import script from "./ResearchItsTechComp.vue?vue&type=script&lang=js"
export * from "./ResearchItsTechComp.vue?vue&type=script&lang=js"

import "./ResearchItsTechComp.vue?vue&type=style&index=0&id=ee72775a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee72775a"]])

export default __exports__